// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"53":"eiendom","25522":"ui","62590":"sbanken","79351":"commons"}[chunkId] + "." + {"53":"0a0ef9f547f91dc07db8","25522":"c002aa132a4d54eef8f0","62590":"82ed3dd0bdf65ae1191a","79351":"b38ca4dead68fa9d2fdd"}[chunkId] + ".css";
};